import React from 'react';

const MatxSidenavContent = ({ children }) => <div className="relative flex-grow h-full">{children}</div>;

export default MatxSidenavContent;
